import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToScaleYourVision() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="19824" id="ready-for-a-brighter-system" className="dark bg-gradient-to-br from-yellow-400 via-orange-500 to-orange-600 py-20 md:py-32 relative overflow-hidden">
      <div ref={ref} className={`mx-auto max-w-7xl px-6 text-center transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h2 className="text-white font-heading text-3xl font-bold sm:text-4xl md:text-5xl tracking-tight">
          Ready for a Brighter System?
        </h2>
        
        <p className="text-white/90 font-sans mx-auto mt-6 max-w-2xl text-lg md:text-xl leading-relaxed">Maximise your solar output and keep your panels performing at their peak. Request your professional clean today.</p>

        <div className="mt-10 flex justify-center">
          <Button asChild className="bg-white text-orange-600 hover:bg-white/95 h-auto rounded-full px-10 py-4 text-lg font-bold shadow-2xl transition-all duration-300 hover:scale-105">
            <Link to="/ContactUsPage">
              REQUEST A QUOTE
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}